import React from 'react';

import {createBasicProps} from './applicationFn.js';

export function mainRenderFn (selectThis) {
  let content = [];
  let props_select = createBasicProps(selectThis.env, 'btb-select');
  let props_content = createBasicProps(selectThis.env, 'select-content');
  let props_input = createBasicProps(selectThis.env, 'content-input');
  let props_inputAddition = createBasicProps(selectThis.env, 'content-inputAddition');
  
  let props_optionList = createBasicProps(selectThis.env, 'select-optionList');

  let props_scrollFlat = createBasicProps(selectThis.env, 'scrollFlat');
  let props_listBody = createBasicProps(selectThis.env, 'optionList-body');
  content.push(
    <div {...props_select} ref={(ref) => {_refHandler(selectThis.env, ref);}}>
      <div {...props_content}>
        <input
          type='text'
          {...props_input}
        />
        <span {...props_inputAddition}>Selector</span>
      </div>
      {
        (selectThis.optionsActive)?
          (
            <div {...props_optionList}>
              {
                (() => {
                  let content_head = [];
                  if (selectThis.env.optionHeadVisible)
                  {
                    let props_listHead = createBasicProps(selectThis.env, 'optionList-head');
                    let props_listHeadRow = createBasicProps(selectThis.env, 'head-row');
                    content_head.push(
                      <div {...props_listHead}>
                        <div {...props_listHeadRow}>
                          {
                            Object.keys(selectThis.env.optionHeadArr).map((entry_header) => {
                              let content_header_cell = [];
                              let props_listHeadCell = createBasicProps(selectThis.env, 'row-cell');
                              content_header_cell.push(
                                <div {...props_listHeadCell}>
                                  {selectThis.env.optionHeadArr[entry_header].text}
                                </div>
                              );
                              return content_header_cell;
                            })
                          }
                        </div>
                      </div>
                    );
                  }
                  return content_head;
                })()
              }
              <div {...props_scrollFlat}>
                <div {...props_listBody}>
                  {
                    (() => {
                      let content_options = [];
                      selectThis.env.optionBodyArr.map((entry_body) => {
                        let isShowing = false;
                        Object.keys(selectThis.env.optionHeadArr).map((entry_header) => {
                          if (-1 != entry_body[entry_header].search(selectThis.printoutData.inputValue))
                          {
                            isShowing = true;
                          }
                        });
                        if (isShowing)
                        {
                          let props_listBodyRow = createBasicProps(selectThis.env, 'body-row');
                          content_options.push(
                            <div 
                              {...props_listBodyRow}
                            >
                              {
                                Object.keys(selectThis.env.optionHeadArr).map((entry_header) => {
                                  let content_optionContent = [];
                                  let props_listBodyCell = createBasicProps(selectThis.env, 'row-cell');
                                  content_optionContent.push(
                                    <div {...props_listBodyCell}>
                                      {entry_body[entry_header]}
                                    </div>
                                  );
                                  return props_listBodyCell;
                                })
                              }
                            </div>
                          );
                        }
                      });
                      return content_options;
                    })()
                  }
                  {
                    (() => {
                      let content_noData = [];
                      if (0 == selectThis.env.optionBodyArr.length)
                      {
                        let props_tr = createBasicProps(selectThis.env, 'row-noData');
                        let props_td = createBasicProps(selectThis.env, 'cell-noData');
                        content_noData.push(
                          <tr {...props_tr}>
                            <td {...props_td}>
                              {selectThis.env.noDataMessage}
                            </td>
                          </tr>
                        );
                      }
                      return content_noData;
                    })()
                  }
                </div>
              </div>
            </div>
          ): []
      }
    </div>
  );
  return content;
}

function _refHandler (env, ref) {
  env.refFn(ref);
}

// function _optionOnClickHandler () {
// function _optionOnClickHandler (env, option) {
//   env.resultData = {
//       data: option,
//       searchInput: (option[this.state['inputShowingAttr']])? option[this.state['inputShowingAttr']] : ''
//   };
//   env._showOptions('off');
// }
